import { OnboardingData } from '@nextforce/api'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useOnboarding } from 'onboarding/service/context'
import { OnboardScreenProps } from 'onboarding/stack/types'
import { OnboardView } from 'onboarding/views/onboard'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'

export default function OnboardScreen({
  navigation,
  route,
}: OnboardScreenProps) {
  const [isLoading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const onboarding = useOnboarding()
  const { phoneNumber, channel } = route.params
  const [onboardingData, setOnboardingData] = useState<OnboardingData>({
    fullName: '',
    storePhoneNumber: '',
    birthMonthDate: '',
    phoneNumber,
    channel,
  })
  const { theme } = useTheme()

  const onSubmit = useCallback(async () => {
    setLoading(true)

    try {
      await onboarding.onboard(onboardingData)
      setErrorMessage(undefined)
      setLoading(false)
      navigation.navigate('activate', {
        phoneNumber,
        profileNeedsReview: true,
      })
    } catch (err: any) {
      setErrorMessage(err.message)
      setLoading(false)
    }
  }, [navigation, onboarding, onboardingData, phoneNumber])

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('finish'),
      onPress: () => onSubmit(),
      position: 'right',
      useIcon: false,
      disabled:
        !onboardingData?.birthMonthDate ||
        !onboardingData?.fullName ||
        !onboardingData?.phoneNumber ||
        !onboardingData?.storePhoneNumber,
    })
  }, [navigation, onSubmit, onboardingData, phoneNumber, theme])

  return (
    <StatusBoundary
      isLoading={isLoading}
      loadingMessage={t('onboarding')}
      error={undefined}
    >
      <OnboardView
        {...{
          errorMessage,
          onboardingData,
          setOnboardingData,
          phoneNumber,
        }}
      />
    </StatusBoundary>
  )
}
